import { RouteConfig } from 'vue-router';
import { tabRoutes } from '@/common/RouteUtils';

export const fuelTankTabs = [
	'general/information',
	'general/change-log',
	'corrections',
	'charts',
	'alerts/manage',
	'alerts/subscriptions',
	'alerts/deleted-subscriptions',
	'alerts/change-log',
	'alerts/sent',
	'allocations',
] as const;

export const fuelProductRoutes: RouteConfig[] = [
	{
		path: '/account/products/fuel/:productId',
		name: 'products.fuel.view',
		component: () => import(/* webpackChunkName: "account" */ './view.vue'),
		meta: { auth: true },
		redirect: { name: 'products.fuel.general.information' },
		children: [
			...tabRoutes('products.fuel', [
				'general/information',
				'general/change-log',
				'general/billing-change-log',
				'partner-orgs',
				'tanks/overview',
				'transceivers',
				'map',
				'users',
				'faults',
				'simpro-jobs',
				'repair-job-texts',
				'sms-charges/current',
				'sms-charges/history',
			]),
			{
				path: 'tanks/:tankId',
				name: 'products.fuel.tanks.detail',
				meta: { auth: true },
				redirect: { name: 'products.fuel.tanks.detail.general.information' },
				children: tabRoutes('products.fuel.tanks.detail', fuelTankTabs),
			},
		],
	},
	{
		path: '/account/products/fuel/:productId/tank/:tankId',
		name: 'products.fuel.tank.view',
		meta: { auth: true },
		redirect: { name: 'products.fuel.tanks.detail.general.information' },
	},
];
